export const FontWeightClasses = {
    HAIRLINE: ['wf-font-hairline'],
    NORMAL: ['wf-font-normal'],
    BOLD: ['wf-font-bold'],
    BLACK: ['wf-font-black']
}